/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_FECHA_DATO,
    CASILLA_TITULO_DATO,
    CASILLA_TITULO_DINERO, CASILLA_TITULO_ESTADO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import Dialogo_Historial from "../Dialogos/Dialogo_Historial";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import {ESTADOHISTORIAL, ESTADOSUSUARIOS} from "../../Constantes";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Historial = () => {
    const cData = useContext(usuarioContext)
    const [wheres, setWheres] = useState([where('idUsuario', '==', cData.usuario.id),
        where('visible', '==', 'Visible')])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Historial,
        titulo: 'Detalles del Movimiento',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }

    useEffect(() => {
        irArriba()
    },[])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de peticiones y administradores'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Historial

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Wallet',
        direccion: 'left',
        propiedad: 'tipo',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Monto',
        direccion: 'left',
        propiedad: 'valor',
        titulo: 'moneda',
        siTitulo: 'PUNTOS',
        tipo: CASILLA_COMPARACION

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        titulo: 'departamento',
        estados: ESTADOHISTORIAL,
        tipo: CASILLA_TITULO_ESTADO,
    },
    {
        nombre: 'Detalle',
        direccion: 'left',
        propiedad: 'detalle',
        fecha: 'fechaRespuesta',
        tipo: CASILLA_FECHA_DATO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]